<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
    <div class="mr-auto">
<!--       <el-form inline ref="form" :model="searchform">

       
          <el-form-item  class="mb-0" style="margin-right:0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="시작"
                  end-placeholder="마감" size="mini" class="mr-2" value-format="yyyy-MM-dd"style="width:200px" >
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchEvent">검색</el-button>  
          </el-form-item>
      </el-form> -->
       
    
    </div>
  <el-table
      :data="tableData"
       v-loading="loading"
       show-summary
       :summary-method="getSummaries"
       style="width: 100%"
       border class="mt-2 el-table-new"
       empty-text="데이타가 없습니다">
         <el-table-column
      type="index"
      width="50">
    </el-table-column>
      
         <el-table-column
        label="아이디" prop="buy_id" align="center" width="110">
          <template slot-scope="scope">
             <div :style="{ backgroundColor :scope.row.RaceYN}">
             <span @click="openModel(scope.row.buy_id)" class="text-primary" style="cursor:pointer">{{scope.row.buy_id}}</span>
           </div>
          </template>
      </el-table-column> 

      <el-table-column
        label="이름" prop="mem_name" align="center">
          <template slot-scope="scope">
            
             <span @click="openLayoutModel(scope)"  style="cursor:pointer">  {{scope.row.mem_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})</span>
          </template>
      </el-table-column> 


    
       <el-table-column
        
        label="겜배팅"  prop="buy_cash" sortable align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.buy_cash)}}</template>
      </el-table-column> 

        <el-table-column
        
        label="이벤배팅"  prop="buy_eventcash"  align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.buy_eventcash)}}</template>
      </el-table-column> 

       <el-table-column
        
        label="겜환불" prop="buy_eventcash" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.buy_eventcash)}}</template>
      </el-table-column> 


 <el-table-column
        
        label="경기전" prop="buy_money0" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.buy_money0)}}</template>
      </el-table-column> 

       <el-table-column
        
        label="적중금액" prop="buy_emoney" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.buy_emoney)}}</template>
      </el-table-column> 

       <el-table-column
        
        label="배당차액" prop="ce" sortable align="center">
         <template slot-scope="scope"><span :class="scope.row.buy_cash - scope.row.buy_emoney < 0 ?'text-danger':'text-primary'">{{ formatMoney(scope.row.buy_cash - scope.row.buy_emoney)}}</span></template>
      </el-table-column> 


     
      
       <el-table-column
        
        label="총입금" prop="io_money" sortable align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.io_money)}}</template>
      </el-table-column> 

       <el-table-column
        
        label="총출금" prop="io_out_money" sortable align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.io_out_money)}}</template>
      </el-table-column>

      <el-table-column
        
        label="입출차액" prop="inoutce" sortable align="center">
         <template slot-scope="scope"><span :class="scope.row.io_money - scope.row.io_out_money < 0 ?'text-danger':'text-primary'">{{ formatMoney(scope.row.io_money - scope.row.io_out_money)}}</span></template>
      </el-table-column>  


       <el-table-column
        
        label="보유금" prop="mem_cash" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>
      </el-table-column> 
      <el-table-column
        
        label="이벤트지급" align="center" prop="" width="200">
         <template slot-scope="scope">
           <div class="d-flex align-items-center">
        <el-input  type="text" style="width: 100px;" v-model="scope.row.input_event" class="mr-1"></el-input><el-button @click="input_eve(scope)" type="primary" plain size="mini" :disabled="scope.row.ac">충전</el-button>
           </div>
         </template>
      </el-table-column> 
       
       
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                    
       
          <el-dialog 
          :visible.sync="dialogModel"
          width="25%" style="height: 500px;overflow: hidden;" :close-on-click-modal ="false">

          <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
            
            <el-form-item label="아이디" class="mb-0">
              <el-input v-model="form.buy_id"  class="w-75"></el-input>
            </el-form-item>
            <el-form-item label="구분" class="mb-0 " >
              <el-select placeholder="선택" v-model="gubun" class="w-75 typeIco">
                  <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="타입" class="mb-0 ">
              <el-select placeholder="선택" v-model="io_type" class="w-75 typeIco">
                  <el-option
                  v-for="item in ioType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="금액" class="mb-0">
              <el-input v-model="form.money" type="number"  class="w-75"></el-input>
            </el-form-item>

             <el-form-item label="메모" class="mb-0">
              <el-input v-model="form.memo" type="text"  class="w-75"></el-input>
            </el-form-item>
         
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="dialogModel = false">취소</el-button>
            <el-button type="primary" @click="cashSumbit">확인</el-button>
          </span>
        
       
       
        </el-dialog> 
				
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';

    export default {
     components: {
      layer
    },
    	data(){
    		return{
                gubun:'',
           form:{
            buy_id:'',
            money:'',
            memo:'',
          },
           io_type:'',
           ioType: [
               {
                label: '충전',
                 value: '1',
               
              }, {
                label: '환전',
                 value: '2',
               
              }],
          options1: [{
               
                label: '게임머니',
                 value: '1',
               
              }, {
                label: '이벤트머니',
                 value: '2',
               
              }],

                 level_title:{
              '-2':'블랙',
              '-1':'대기',
              '0':'기본'             
            },
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
           bg:window.sessionStorage.getItem('bg'),
    		  formLoading:false,
          idDialogVisible: false,
    			typeObj:{
              
              '1':'배팅', 
              '2':'입금',
              '3':'출금',
              '4':'이벤트전환',
              '5':'이벤트지급',
              '6':'총판롤링',
              '7':'당첨',
              '8':'부본사롤링',
              '9':'회원롤링',
 
            },
  
		    	
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
                     dialogModel:false,
		    		 tableData: [],
             searchform:{
                time:[],
             },
              pickerOptions: {
          },
          shortcuts: [{
            text: '최근한주',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근한달',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근3개월',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
			     
	
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
   
    	methods:{
         getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '합계';
            return;
          }
         else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 6) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 7) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 8) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 9) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 10) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 11) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 12) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
    
        // 搜索事件
      searchEvent(){

              
          this.getList();
          
             this.currentPage=1;

        },
        
              openLayoutModel(e){
                  this.dialogModel = true
                  this.form.buy_id = e.row.buy_id
                },
            input_eve(e){

               // console.log('e',e);
                e.row.ac = true
                let token=window.sessionStorage.getItem('user');
                
                this.$axios({
                      method:'post',
                      url:this.domain+'/admin/cash_event_up',
                      data:{
                        mem_id:e.row.buy_id,
                        money:e.row.input_event,
                        gubun:'2',
                        io_type:'1'
                      },
                      'Accept': 'application/json',
                       headers: { 'Authorization': 'Bearer ' + token },
        
                }).then((response) =>{ 
                       
                  
                    
                      let item = response.data.data
                  
                      if(response.data.code==200){
                       

                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                    }else
                    {
                         this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                      
                       
                   e.row.ac = false
                   
                }).catch((error) =>{
                    console.log(error)       //请求失败返回的数据
                })


},
          // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
         cashSumbit(){
          let token=window.sessionStorage.getItem('user');
           this.loading = true
              this.$axios({
                    method:'post',
                    url:this.domain+'/admin/cash_event_up',
                    data:{
                      mem_id:this.form.buy_id,
                      money:this.form.money,
                      memo:this.form.memo,
                      gubun:this.gubun,
                      io_type:this.io_type
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                
                     this.loading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
            

                     this.form.buy_id=''
                     this.form.money=''
                     this.form.memo=''
                       this.dialogModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })
        },
         openModel(id){
          let pix=window.screen.width;
          let layerwidth='950px';
                if(pix<1200)
                {
                  layerwidth='95%';
                }
          this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: [layerwidth+'', '680px'],
        
        });
        },
   
    		
       
    		getList(){
           let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

    			 this.loading = true
    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/loss_race?s_time='+s_time+'&e_time='+e_time;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('data=',response.data.data)
                     let data = response.data.data
                     this.tableData =data
                    
                     
                     this.loading =false
               
            }).catch((error) =>{
            
               this.$message.error(error);
              this.loading = false
               
            })
    		},
    		
    		
    	
    		
    	}
  }
</script>

 <style scoped>
/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
 /deep/.typeIco .el-input__icon{
  line-height: 30px;
 }
/deep/ .el-table-new td.el-table__cell{
    border-bottom: 2px solid #c3c3c3;
}

</style>


// WEBPACK FOOTER //
// src/views/lossrace/list.vue